// 导入封装的方法
import {
  post
} from '../http'

const internetPolitics = {
  survey: {
    list (params) {
      return post('/survey/website/list', params)
    },
    info (params) {
      return post('/survey/infoModelExtranet/' + params)
    }
     

  },
  linkagehistoricalcollect: {
    selectPhone (params) {
      return post('/linkagehistoricalcollect/selectPhone', params)
    },
    info (params) {
      return post('/linkagehistoricalcollect/info/' + params)
    },
    list (params) {
      return post('/officeonlineletter/officeOnlineListByPhone', params)
    }
  },
  comment: {
    selectPhone (params) {
      return post('/comment/selectPhone', params)
    },
    info (params) {
      return post('/comment/info/' + params)
    }
  }
}
export default internetPolitics
